class Tutorial {
  constructor(windowSizes) {
    this.duration = 1.5;
    this.windowSizes = windowSizes;

    this.container = document.querySelector(".fonc__section--form");
    this.clicked = 0;

    if (this.container) {
      this.button = this.container.querySelector(".tutorial__link--func");
      this.items = this.container.querySelectorAll(".fonc__section__items__li");
      this.totalClicks = this.items.length;
      this.init();
    }
  }

  init() {
    this.initStyle();
    this.initEvents();
  }

  initStyle() {
    this.button.classList.add("tutorial__link--disabled");
  }

  initEvents() {
    Array.from(this.items, (item, index) => {
      item.addEventListener("click", () => {
        this.onLiClick(index, item);
      });
    });
  }

  onLiClick(index, item) {
    item.removeEventListener("click", () => {
      this.onLiClick(index, item);
    });
    //if (index === this.clicked) {
    this.clicked++;
    item.classList.add("fonc__section__items__li--form--active");
    item.style.pointerEvents = "none";
    if (this.items[this.clicked]) {
      this.items[this.clicked].style.pointerEvents = "auto";
    }

    if (this.clicked === this.totalClicks) {
      this.button.classList.remove("tutorial__link--disabled");
      const btn = this.button.querySelector(".search-side__button__over--func");
      btn.innerHTML = "Accès au formulaire";
    }
    //}
  }

  /** Resize Event */
  resize(windowSizes) {
    this.windowSizes = windowSizes;
  }
}

export default Tutorial;



// WEBPACK FOOTER //
// ./src/js/components/Tutorial.js